module.exports = __webpack_public_path__ + "img/mewtopia.ed6f9247.svg";